import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import '../styles.css';

const LeaveDecision = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [leaveRequest, setLeaveRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cancelled, setCancelled] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const navigate = useNavigate();
  const currentUserId = localStorage.getItem('id');

  useEffect(() => {
    const screenWidth = window.innerWidth;
    setIsSidebarVisible(screenWidth >= 520);
  }, []);

  const handleToggleClick = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  useEffect(() => {
    if (currentUserId) {
      axiosInstance.get(`/user/${currentUserId}/`)
        .then((response) => {
          setUserData(response.data);
          return axiosInstance.get(`/get-leave-request/${id}/`);
        })
        .then((response) => {
          setLeaveRequest(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          setLoading(false);
        });
    }
  }, [currentUserId, id]);

  const handleApproveRequest = () => {
    axiosInstance.post(`/leave-requests/${id}/decision/`, { status: 'approved' })
      .then((response) => {
        console.log('Leave request approved successfully');
        setLeaveRequest({ ...leaveRequest, status: 'approved' });
      })
      .catch((error) => console.error('Error approving leave request:', error));
  };

  const handleRejectRequest = () => {
    axiosInstance.post(`/leave-requests/${id}/decision/`, { status: 'rejected' })
      .then((response) => {
        console.log('Leave request rejected successfully');
        setLeaveRequest({ ...leaveRequest, status: 'rejected' });
      })
      .catch((error) => console.error('Error rejecting leave request:', error));
  };

  const handleCancelRequest = (leaveRequest) => {
    axiosInstance.post(`/cancel-leave-request/${leaveRequest.id}/`)
      .then((response) => {
        console.log('Leave request cancelled successfully');
        setCancelled(true);
      })
      .catch((error) => console.error('Error cancelling leave request:', error));
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const menuItems = [
    { icon: '&#127968;', label: 'Dashboard', path: '/admin-manager-lead-dashboard' },
    { icon: '&#128196;', label: 'AR Requests', path: '/all-requests' },
    // { icon: '&#128197;', label: 'Calendar', path: '/calendar' },
    ...(userData?.role_name === 'admin' || userData?.role_name === 'manager' ? [
      { icon: '&#128101;', label: 'Employees', path: '/employees' },
      { icon: '&#127970;', label: 'Roles & Office', path: '/roles-office' },
    ] : []),
  ];

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return 'status-approved';
      case 'rejected':
        return 'status-rejected';
      case 'pending':
        return 'status-pending';
      default:
        return 'status-default';
    }
  };

  return (
    <div className={`dashboard-wrapper ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header
        onToggleClick={handleToggleClick}
        isSidebarVisible={isSidebarVisible}
      />
      
      <Sidebar
        isSidebarVisible={isSidebarVisible}
        currentUser={userData}
        menuItems={menuItems}
        handleLogout={handleLogout}
      />
      
      <main className="dashboard-main-content">
        <div className="dashboard-header-section">
          <h1>📋 Leave Decision</h1>
          <p>Review and approve leave requests</p>
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        ) : leaveRequest ? (
          <div className="dashboard-card">
            <div className="leave-decision-detail">
              <div className="decision-info-grid">
                <div className="decision-info-item">
                  <span className="decision-label">Applied On</span>
                  <span className="decision-value">{new Date(leaveRequest.created_at).toLocaleString()}</span>
                </div>
                <div className="decision-info-item">
                  <span className="decision-label">Employee</span>
                  <span className="decision-value">{leaveRequest.user_name} ({leaveRequest.user})</span>
                </div>
                <div className="decision-info-item">
                  <span className="decision-label">Leave Type</span>
                  <span className="decision-value">{leaveRequest.leave_type_name}</span>
                </div>
                <div className="decision-info-item">
                  <span className="decision-label">Start Date</span>
                  <span className="decision-value">{new Date(leaveRequest.start_date).toLocaleDateString()}</span>
                </div>
                <div className="decision-info-item">
                  <span className="decision-label">End Date</span>
                  <span className="decision-value">{new Date(leaveRequest.end_date).toLocaleDateString()}</span>
                </div>
                <div className="decision-info-item">
                  <span className="decision-label">Duration</span>
                  <span className="decision-value">{leaveRequest.leave_duration}</span>
                </div>
                <div className="decision-info-item full-width">
                  <span className="decision-label">Reason</span>
                  <span className="decision-value">{leaveRequest.reason}</span>
                </div>
                <div className="decision-info-item">
                  <span className="decision-label">Status</span>
                  <span className={`decision-status-badge ${getStatusBadgeClass(leaveRequest.status)}`}>
                    {leaveRequest.status}
                  </span>
                </div>
              </div>

              <hr className="decision-divider" />

              {cancelled ? (
                <div className="decision-success-message">
                  <span>✓</span> Request Cancelled Successfully!
                </div>
              ) : (
                <div className="decision-actions">
                  <button 
                    className="decision-btn approve-btn" 
                    onClick={handleApproveRequest}
                  >
                    <span className="btn-icon">✓</span>
                    Approve
                  </button>
                  <button 
                    className="decision-btn reject-btn" 
                    onClick={handleRejectRequest}
                  >
                    <span className="btn-icon">✗</span>
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="dashboard-card">
            <div className="no-data-message">
              <p>No leave request found.</p>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default LeaveDecision;

